import { Box, Button, Divider, Drawer, Paper, Typography, useMediaQuery, useTheme, Link as MUILink } from '@mui/material';
import React, { Children, useEffect, useState } from 'react';
import { Container, DataTextBox, InfoBox, LeftBox } from './style';
import BusinessListItem from './BusinessListItem';
import RightPaperBox from './RightPaper';
import { MainHeading, ParaText } from '../../style/GlobalStyles';
import InfoIcon from '../../icons/InfoIcon';
import NewTaskAddButton from './NewTaskAddButton';
import FilterByCompany from '../../components/FilterByCompany';
import DrawerHeaderBox from '../../components/DrawerHeaderBox';
import { useSelector, useDispatch } from 'react-redux';
import { selectChecklistData, selectChecklistStatus, selectChecklistError, initializeAsync, updateChecklistAsync, initializeWithoutLoadAsync, removeChecklistAsync } from './checklistSlice';
import { TASK_STATUS_CONSTANTS } from '../../contants';
import { skeleton } from './skeleton';
import { useAuth } from '../../hooks/useAuth';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import ShowAddedCompanyBox from '../../components/ShowAddedCompanyBox';
import FilterByStatus from '../../components/FilterByStatus';
import ShowAddedTaskStatusBox from '../../components/ShowAddedTaskStatusBox';
import { CustomChip } from '../../components/CustomChip';
import Modal from '../../components/Modal';
import { post } from '../../api';

function MyBusinessChecklistPage() {
    const data = useSelector(selectChecklistData);
    const status = useSelector(selectChecklistStatus);
    const error = useSelector(selectChecklistError);
    const dispatch = useDispatch();
    const [currentSelectedItem, setCurrentSelectedItem] = useState({});
    const [categoryDetails, setCategoryDetails] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [expandedItemId, setExpandedItemId] = useState('');
    const [loading, setLoading] = useState(true);
    const [selectedCompanyList, setSelectedCompanyList] = useState([]);
    const [selectedStatusFiltersList, setSelectedStatusFiltersList] = useState([]);
    const [taskDeleteModalIsOpen, setTaskDeleteModalIsOpen] = useState(false);
    const [taskToDelete, setTaskToDelete] = useState(null);
    const [hasPersonalProducts, setHasPersonalProducts] = useState();

    const theme = useTheme();
    const isMobileView = useMediaQuery(theme.breakpoints.down('md'));
    const location = useLocation();
    const navigate = useNavigate();

    const searchParams = new URLSearchParams(location.search);

    const selectedItemDetails = {
        selectedNavId: searchParams.get('selectedNavId'),
        selectedListItemId: searchParams.get('selectedListItemId'),
    };

    const { getUserDetailsNotAsync, setUserDetailsNotAsync, refreshSessionData } = useAuth();
    const userDetails = getUserDetailsNotAsync();

    const selectedNavItem = categoryDetails.find((cItem) => cItem.id === selectedItemDetails?.selectedNavId);

    useEffect(() => {
        if (status === 'idle') {
            dispatch(initializeAsync({ accountIds: userDetails.businessList?.map((item) => item.accountId) }));
        }
    }, [status, dispatch]);

    useEffect(() => {
        post('custom/checkUserHasPersonalProduct', { accountIds: userDetails.contact.relatedAccounts?.map((item) => item.accountId) }).then((result) => {
            if (result.isSuccess && result.data === 'true') {
                setHasPersonalProducts(true);
            } else {
                setHasPersonalProducts(false);
            }
        });
    }, []);

    useEffect(() => {
        if (status !== 'idle') {
            dispatch(initializeWithoutLoadAsync({ accountIds: userDetails.businessList?.map((item) => item.accountId) }));
        }
    }, [location.pathname]);

    useEffect(() => {
        let selectedListItem = selectedNavItem?.tasks.find((cItem) => {
            return cItem.id === selectedItemDetails.selectedListItemId;
        });

        // added providers list manually here
        //it should be removed from start to end
        // start
        selectedListItem = selectedListItem && {
            ...selectedListItem,
            providers: [
                {
                    img: '/images/other/quickbooks.png',
                    title: 'QuickBooks',
                    tag: 'Best Overall',
                    link: '',
                },
                {
                    img: '/images/other/zoho.png',
                    title: 'ZOHO',
                    tag: 'Best Freelancers',
                    link: '',
                },
                {
                    img: '/images/other/wave.png',
                    title: 'Wave',
                    tag: 'Budget pickrs',
                    link: '',
                },
            ],
        };
        // end

        setCurrentSelectedItem(selectedListItem || {});
        selectedListItem ? toggleDrawer(true) : toggleDrawer(false); //open drawer only if selected item present
    }, [selectedItemDetails.selectedListItemId, selectedNavItem]);

    useEffect(() => {
        // catagories filters catagories list
        if (data.records?.length > 0) {
            let maindata = {};

            let mapCategory = {};
            for (let record of data.records) {
                let solutionCategoryId = record.solutionCategoryId ? record.solutionCategoryId : 'other';
                if (!mapCategory[solutionCategoryId]) {
                    mapCategory[solutionCategoryId] = { id: solutionCategoryId, name: record.solutionCategoryName ? record.solutionCategoryName : 'Other', tasks: [] };
                }
                mapCategory[solutionCategoryId].tasks.push(record);
            }

            maindata = Object.values(mapCategory);

            if (selectedCompanyList?.length || selectedStatusFiltersList?.length) {
                // if filters are applied, added filters and show data according it
                let newCatagoryList = [];
                for (let index = 0; index < maindata.length; index++) {
                    const category = maindata[index];
                    let newTasks = [];
                    let newCatagory = {};

                    for (let index = 0; index < category.tasks.length; index++) {
                        let task = category.tasks[index];
                        let newCompanyTasks = [...task.companyTasks];

                        if (selectedCompanyList.length) {
                            const filteredTasksList = [];
                            for (let index = 0; index < task.companyTasks.length; index++) {
                                const companyTask = task.companyTasks[index];

                                if (
                                    selectedCompanyList.find((cSelectedCompany) => cSelectedCompany.id === companyTask.companyId)
                                    // selectedStatusFiltersList.find((cSelectedCompany) => cSelectedCompany.status === companyTask.status)
                                ) {
                                    filteredTasksList.push({ ...companyTask });
                                }
                            }
                            newCompanyTasks = [...filteredTasksList];
                        }

                        if (selectedStatusFiltersList.length) {
                            const filteredTasksList = [];
                            for (let index = 0; index < task.companyTasks.length; index++) {
                                const companyTask = task.companyTasks[index];

                                if (selectedStatusFiltersList.find((cSelectedCompany) => cSelectedCompany.status === companyTask.status)) {
                                    filteredTasksList.push({ ...companyTask });
                                }
                            }
                            newCompanyTasks = [...filteredTasksList];
                        }

                        if (selectedCompanyList.length && selectedStatusFiltersList.length) {
                            const filteredTasksList = [];
                            for (let index = 0; index < task.companyTasks.length; index++) {
                                const companyTask = task.companyTasks[index];

                                if (
                                    selectedCompanyList.find((cSelectedCompany) => cSelectedCompany.id === companyTask.companyId) &&
                                    selectedStatusFiltersList.find((cSelectedCompany) => cSelectedCompany.status === companyTask.status)
                                ) {
                                    filteredTasksList.push({ ...companyTask });
                                }
                            }
                            newCompanyTasks = [...filteredTasksList];
                        }

                        const newTask = {
                            ...task,
                            // companyTasks:newCompanyTasks.length>0?newCompanyTasks:task.companyTasks
                            companyTasks: newCompanyTasks,
                        };
                        newCompanyTasks.length > 0 && newTasks.push(newTask);
                    }

                    newCatagory = {
                        ...category,
                        tasks: newTasks,
                    };
                    newTasks.length > 0 && newCatagoryList.push({ ...newCatagory });
                }
                setCategoryDetails(newCatagoryList);
            } else {
                // if filters are not applied set all catagories list
                setCategoryDetails(maindata);
            }
        }
    }, [data.records, selectedCompanyList, selectedStatusFiltersList]);

    const handleDeleteTask = () => {
        if (!taskToDelete) {
            closeDeleteTaskModal();
            return;
        }
        // remove current record from records
        dispatch(removeChecklistAsync(taskToDelete));

        closeDeleteTaskModal();

        // if selected item and deleted item are not same then just return
        if (currentSelectedItem?.id !== taskToDelete?.id) {
            return;
        }

        const newParams = new URLSearchParams(location.search);
        newParams.delete('selectedNavId');
        newParams.delete('selectedListItemId');

        const queryString = newParams.toString();

        navigate(`${location.pathname}${queryString ? `?${queryString}` : ''}`);
    };

    const openDeleteTaskModal = (currentTask) => {
        setTaskToDelete(currentTask);
        setTaskDeleteModalIsOpen(true);
    };
    const closeDeleteTaskModal = () => {
        setTaskToDelete(null);
        setTaskDeleteModalIsOpen(false);
    };

    const toggleDrawer = (newOpen) => setOpen(newOpen);

    const handleBack = () => {
        setCurrentSelectedItem({});
        toggleDrawer(false);

        const newParams = new URLSearchParams(location.search);
        newParams.delete('selectedNavId');
        newParams.delete('selectedListItemId');
        navigate(`${location.pathname}?${newParams.toString()}`);
    };

    const getChecklistStatus = () => {
        return [
            {
                dataValue: data.records?.length,
                dataText: 'Task added',
                status: TASK_STATUS_CONSTANTS.TASK_ADDED,
            },
            // {
            //     dataValue: data.records?.filter((item) => {
            //         return item.companyTasks.filter((innerItem) => innerItem.status === 'Not Started').length === item.companyTasks.length;
            //     }).length,
            //     dataText: 'Not started',
            //     status: TASK_STATUS_CONSTANTS.TASK_NOT_STARTED,
            // },

            // {
            //     dataValue:
            //         data.records?.length -
            //         data.records?.filter((item) => {
            //             return item.companyTasks.filter((innerItem) => innerItem.status === 'Not Started').length === item.companyTasks.length;
            //         }).length -
            //         data.records?.filter((item) => {
            //             return item.companyTasks.filter((innerItem) => innerItem.status === 'Completed').length === item.companyTasks.length;
            //         }).length,
            //     dataText: 'In progress',
            //     status: TASK_STATUS_CONSTANTS.TASK_IN_PROGRESS,
            // },
            {
                dataValue: data.records?.filter((item) => {
                    return item.companyTasks.filter((innerItem) => innerItem.status === 'Completed').length === item.companyTasks.length;
                }).length,
                dataText: 'Completed',
                status: TASK_STATUS_CONSTANTS.TASK_COMPLETED,
            },
        ];
    };

    const updateChecklists = (newChecklist) => {
        dispatch(updateChecklistAsync(newChecklist));
    };

    const handleCompanyFilterChange = (selectedCompanyIds) => setSelectedCompanyList(selectedCompanyIds);
    const handleStatusFilterChange = (selectedStatusIds) => setSelectedStatusFiltersList(selectedStatusIds);

    const getRightPaperBox = (isDrawer = false) => {
        return (
            <Box
                component={Paper}
                variant={isDrawer ? 'elevation' : 'outlined'}
                sx={{
                    overflow: 'auto',
                    width: { xs: '100%', md: '40%' },
                    marginLeft: {
                        xs: '0',
                        md: '1.5rem',
                    },
                }}
            >
                <RightPaperBox
                    currentSelectedItem={currentSelectedItem}
                    setCurrentSelectedItem={setCurrentSelectedItem}
                    selectedItemDetails={selectedItemDetails}
                    updateChecklists={updateChecklists}
                    openDeleteTaskModal={openDeleteTaskModal}
                />
            </Box>
        );
    };

    return status === 'initialLoading' ? (
        skeleton
    ) : (
        <Container>
            <LeftBox>
                <Box
                    display={'flex'}
                    justifyContent={'space-between'}
                    alignItems={'center'}
                    sx={{
                        '@media (max-width:600px)': {
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            alignItems: 'flex-start',

                            '& h1': {
                                marginBottom: '1rem',
                            },
                        },
                    }}
                >
                    <MainHeading>My Business Checklist</MainHeading>
                    <NewTaskAddButton hasPersonalProducts={hasPersonalProducts} updateChecklists={updateChecklists} />
                </Box>
                <ParaText marginTop={theme.typography.generic.xSmall}>Create and manage custom checklists to keep your businesses on track.</ParaText>

                <DataTextBox>
                    {getChecklistStatus().map((cTaskDetails, index) => (
                        <React.Fragment key={index}>
                            <Box className="item" key={index} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                                <CustomChip label={cTaskDetails.dataValue} />
                                <Typography component={'p'} variant="paraText2" color="text.secondary" marginLeft={theme.typography.generic.xSmall} minWidth={'75px'}>
                                    {cTaskDetails.dataText}
                                </Typography>
                            </Box>
                            <Divider
                                orientation="vertical"
                                variant="middle"
                                flexItem
                                sx={{
                                    margin: `${theme.typography.generic.none} ${theme.typography.generic.xxxLarge}`,
                                    color: theme.palette.grey[300],
                                }}
                            />
                        </React.Fragment>
                    ))}
                </DataTextBox>

                <Box
                    display={'flex'}
                    gap={'1rem'}
                    marginBottom={theme.typography.generic.xxxxxLarge}
                    sx={{
                        flexDirection: { xs: 'column', sm: 'row' },
                        width: {
                            xs: '13.18rem',
                            sm: '100%',
                        },
                    }}
                >
                    {hasPersonalProducts != undefined && <FilterByCompany hideHousehold={!hasPersonalProducts} selectedCompanyList={selectedCompanyList} onChange={handleCompanyFilterChange} />}
                    <FilterByStatus selectedStatusList={selectedStatusFiltersList} onChange={handleStatusFilterChange} />
                </Box>

                <Box>
                    <ShowAddedCompanyBox selectedCompanyList={selectedCompanyList} sx={{ margin: 0 }} />
                    <ShowAddedTaskStatusBox selectedStatusList={selectedStatusFiltersList} sx={{ margin: 0, marginTop: '0.5rem' }} />
                </Box>

                {categoryDetails?.map((cItem, index) => (
                    <BusinessListItem
                        index={index}
                        key={cItem.id}
                        cItem={cItem}
                        expandedItemId={expandedItemId}
                        setExpandedItemId={setExpandedItemId}
                        currentSelectedItem={currentSelectedItem}
                        setCurrentSelectedItem={setCurrentSelectedItem}
                        selectedItemDetails={selectedItemDetails}
                        toggleDrawer={toggleDrawer}
                        openDeleteTaskModal={openDeleteTaskModal}
                        updateChecklists={updateChecklists}
                    />
                ))}

                <InfoBox>
                    <InfoIcon />
                    <Typography color={'info.main'} fontSize={'customFontSize.medium'} fontWeight={'fontWeightMedium'} lineHeight={'customFontSize.xLarge'}>
                        <MUILink
                            component={Link}
                            color="inherit" // inherit from Typography
                            underline="none"
                            sx={{
                                textDecorationColor: 'inherit',
                                '&:hover': {
                                    textDecoration: 'underline',
                                    textDecorationColor: 'inherit',
                                },
                            }}
                            to={'/business-navigator'}
                        >
                            Add a task from the Business Navigator
                        </MUILink>{' '}
                        or create your own.
                    </Typography>
                </InfoBox>
            </LeftBox>

            {isMobileView ? (
                <Drawer
                    open={open}
                    onClose={() => toggleDrawer(false)}
                    anchor="right"
                    PaperProps={{
                        sx: {
                            width: '100%',
                        },
                    }}
                >
                    <DrawerHeaderBox handleBack={handleBack} heading={selectedNavItem?.name} para={selectedNavItem?.para} />
                    {getRightPaperBox(true)}
                </Drawer>
            ) : (
                getRightPaperBox()
            )}

            <Modal
                modalOpen={taskDeleteModalIsOpen}
                handleModalClose={closeDeleteTaskModal}
                handleModalOnSuccess={handleDeleteTask}
                title={<Box sx={{ color: theme.palette.error.main }}>Confirm Deletion</Box>}
                sx={{}}
                submitBtnProps={{
                    color: 'error',
                    children: 'Delete',
                }}
            >
                {/* {taskToDelete?.name} */}
                Are you sure you want to delete this task? This action cannot be undone.
            </Modal>
        </Container>
    );
}

export default MyBusinessChecklistPage;
